// removed by extract-text-webpack-plugin
module.exports = {"business-content-container":"business-content-container","no-content":"no-content"};


//////////////////
// WEBPACK FOOTER
// ./components/my-business/profile/_business-content-container.scss
// module id = ./components/my-business/profile/_business-content-container.scss
// module chunks = 0